// src/context/UserContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import API from '../api';

const UserCtx = createContext({
    user: null,
    loading: false,
    error: null,
    refresh: () => { },
});

export const useCurrentUser = () => useContext(UserCtx);

// Optional: small helper to watch token changes
function getToken() {
    return localStorage.getItem('token') || '';
}

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [token, setToken] = useState(getToken());

    const refresh = async () => {
        const t = getToken();
        if (!t) {
            setUser(null);
            setLoading(false);
            setError(null);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await API.get('/me');
            setUser(res.data || null);
        } catch (e) {
            console.error('GET /me failed:', e);
            setUser(null);
            setError('Failed to load profile');
        } finally {
            setLoading(false);
        }
    };

    // Load once on mount
    useEffect(() => {
        refresh();

    }, []);

    // React to token changes within the same tab
    useEffect(() => {
        const i = setInterval(() => {
            const t = getToken();
            if (t !== token) {
                setToken(t);
                refresh();
            }
        }, 800); // lightweight polling to catch token set right after login
        return () => clearInterval(i);
    }, [token]);

    // React to cross-tab token changes
    useEffect(() => {
        const onStorage = (e) => {
            if (e.key === 'token') {
                setToken(getToken());
                refresh();
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    return (
        <UserCtx.Provider value={{ user, loading, error, refresh }}>
            {children}
        </UserCtx.Provider>
    );
};
